function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M473.7 485.75c6.8 0 12.3-5.5 12.3-12.3v-359.8c0-3.6-1.6-7-4.3-9.3L363 2.85c-.2-.2-.4-.3-.6-.4-.3-.2-.5-.4-.8-.6-.4-.2-.7-.4-1.1-.6-.3-.1-.6-.3-.9-.4-.4-.2-.9-.3-1.3-.4-.3-.1-.6-.2-.9-.2-.8-.1-1.5-.2-2.3-.2H12.3C5.5.05 0 5.55 0 12.35v461.3c0 6.8 5.5 12.3 12.3 12.3h461.4v-.2zm-89.2-24.5h-283v-184.1c0-3.7 3-6.6 6.6-6.6h269.8c3.7 0 6.6 3 6.6 6.6v184.1zM161.8 24.45h180.9v127.8c0 .8-.6 1.4-1.4 1.4h-178c-.8 0-1.4-.7-1.4-1.4V24.45h-.1zm-137.2 0h112.8v127.8c0 14.3 11.6 25.9 25.9 25.9h178c14.3 0 25.9-11.6 25.9-25.9V38.75l94.2 80.6v341.9H409v-184.1c0-17.2-14-31.1-31.1-31.1H108.1c-17.2 0-31.1 14-31.1 31.1v184.2H24.6V24.45z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M227.4 77.65h53.8v32.6c0 6.8 5.5 12.3 12.3 12.3s12.3-5.5 12.3-12.3v-44.8c0-6.8-5.5-12.3-12.3-12.3h-66.1c-6.8 0-12.3 5.5-12.3 12.3s5.6 12.2 12.3 12.2zM304.5 322.85h-123c-6.8 0-12.3 5.5-12.3 12.3s5.5 12.3 12.3 12.3h123c6.8 0 12.3-5.5 12.3-12.3s-5.5-12.3-12.3-12.3zM304.5 387.75h-123c-6.8 0-12.3 5.5-12.3 12.3s5.5 12.3 12.3 12.3h123c6.8 0 12.3-5.5 12.3-12.3s-5.5-12.3-12.3-12.3z"
});

var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9193A9",
    viewBox: "0 0 486 486"
  }, props), _ref, _ref2);
};

export default SvgSave;